import type { PrototypeLink } from "@/document/model/document";
import { prototypeLinks, replacePrototypeLinks, upsertPrototypeLink } from "@/document/model/prototype";
import type { Command, CommandContext, CommandResult } from "./Command";

export class UpsertPrototypeLinkCommand implements Command {
  readonly id = "prototype.upsertLink";
  readonly label = "Update Prototype Link";

  private beforeLinks?: PrototypeLink[];

  constructor(private readonly link: PrototypeLink) {}

  execute(context: CommandContext): CommandResult {
    this.beforeLinks = prototypeLinks(context.document).map(link => structuredClone(link));
    upsertPrototypeLink(context.document, this.link);
    return this.result();
  }

  undo(context: CommandContext): CommandResult {
    replacePrototypeLinks(context.document, this.beforeLinks ?? []);
    return this.result();
  }

  redo(context: CommandContext): CommandResult {
    upsertPrototypeLink(context.document, this.link);
    return this.result();
  }

  private result(): CommandResult {
    return {
      changedNodeIds: [this.link.sourceNodeId, this.link.targetFrameId],
      affectedBounds: [],
    };
  }
}

export class DeletePrototypeLinkCommand implements Command {
  readonly id = "prototype.deleteLink";
  readonly label = "Delete Prototype Link";

  private beforeLinks?: PrototypeLink[];
  private deletedLink?: PrototypeLink;

  constructor(private readonly linkId: string) {}

  execute(context: CommandContext): CommandResult {
    this.beforeLinks = prototypeLinks(context.document).map(link => structuredClone(link));
    this.deletedLink = this.beforeLinks.find(link => link.id === this.linkId);
    replacePrototypeLinks(context.document, this.beforeLinks.filter(link => link.id !== this.linkId));
    return this.result();
  }

  undo(context: CommandContext): CommandResult {
    replacePrototypeLinks(context.document, this.beforeLinks ?? []);
    return this.result();
  }

  redo(context: CommandContext): CommandResult {
    replacePrototypeLinks(context.document, prototypeLinks(context.document).filter(link => link.id !== this.linkId));
    return this.result();
  }

  private result(): CommandResult {
    return {
      changedNodeIds: this.deletedLink ? [this.deletedLink.sourceNodeId, this.deletedLink.targetFrameId] : [],
      affectedBounds: [],
    };
  }
}
